import {ViewController} from "data/types/structure";
import {inject, injectable} from "inversify";
import {Bindings} from "data/constants/bindings";
import {makeAutoObservable, observable} from "mobx";
import type {ILocalizationStore} from "data/stores/localization/localization.store";
import type {ISquad, ISquadsStore} from "data/stores/squads/squads.store";
import type {
	IContestPlayer,
	IContestPlayersStore,
} from "data/stores/contest_players/contest_players.store";

interface IProps {
	player: IContestPlayer;
}
export interface IWinnerCardController extends ViewController<IProps> {
	readonly i18n: ILocalizationStore;

	get squadByPlayer(): ISquad | null | undefined;
}

@injectable()
export class WinnerCardController implements IWinnerCardController {
	@observable private _player!: IContestPlayer;

	get squadByPlayer() {
		if (!this._player) return null;

		return this._squadsStore.getSquadById(this._player.squadId);
	}

	constructor(
		@inject(Bindings.LocalizationStore) public readonly i18n: ILocalizationStore,
		@inject(Bindings.SquadsStore) public _squadsStore: ISquadsStore,
		@inject(Bindings.ContestPlayersStore) public _contestPlayersStore: IContestPlayersStore
	) {
		makeAutoObservable(this);
	}

	init({player}: IProps) {
		this._player = player;
	}
}
